import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import config from '../../config';
import {
  Page,
  SectionHero,
  SectionHowItWorks,
  SectionLocations,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';

import instagram from './instagram.png';

import facebookImage from '../../assets/pethomerFacebook-1200x630.png';
import twitterImage from '../../assets/pethomerTwitter-600x314.png';
import sliderWebinarDesktop from '../../assets/slider_webinar_desktop.webp';
import sliderWebinarMobile from '../../assets/slider_webinar_mobile.webp';
import wojtkow from '../../assets/wojtkow.webp';
import wojtkowMobile from '../../assets/wojtkow_mobile.webp';
import przysmak from '../../assets/przysmak_deskto.webp';
import przysmakMobile from '../../assets/przysmak_mobile.webp';
import pethelp from '../../assets/pethelp_desktop.webp';
import pethelpMobile from '../../assets/pethelp_mobile.webp';

import css from './LandingPage.module.css';
import SecondSection from './SecondSection/SecondSection';
import ReviewSection from './ReviewSection/ReviewSection';
import MediaMentions from './MediaMentions/MediaMentions';
import InstagramEmbed from 'react-instagram-embed';
import ThirdSection from './ThirdSection/ThirdSection';
import NewsletterSection from './NewsletterSection/NewsletterSection';
import { Button } from '../../components';
import DynamicBanner from './DynamicBanner';

export const LandingPageComponent = props => {
  const { history, intl, location, scrollingDisabled } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  const sliderURL = 'https://zoocial.pl/market/pakiety-weterynaryjne/';
  const sliderURL2 = 'https://zoocial.pl/market/marketplace/seller/profile/shop/Wojtkow/';

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="LandingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <SectionHero className={css.hero} history={history} location={location} />
          <SecondSection />
            <DynamicBanner configUrl="https://buck.zoocial.pl/main-banner-config.json" />
          <div className={css.instagramEmbedContainer}>
            <div className={css.instagramEmbed}>
              <div>
                <div style={{ width: '100%' }}>
                  <p className={css.header}>
                    <FormattedMessage id="Instagram.title" />
                    <img style={{ marginLeft: '0.5rem', width: '170px' }} src={instagram} />
                  </p>
                </div>
              </div>
              <div
                class="elfsight-app-6bb84a3e-112c-4ddb-a06b-4f9a752e5b6e"
                style={{ width: '100%' }}
              ></div>
            </div>
          </div>
          <ThirdSection />
          <ReviewSection />
            <DynamicBanner configUrl="https://buck.zoocial.pl/second-banner-config.json" />
          <MediaMentions />
          <NewsletterSection />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(LandingPageComponent);

export default LandingPage;
